import React from 'react';
import Boxable from './Boxable';
import Box from './Box';
import './DragThingsToBoxesDemo.css';

export default class DragThingsToBoxesDemo extends React.Component {
 
  render() {
  
    return (
      <div className="drag_things_to_boxes">
        <div className="boxes">
          <Box targetKey="box" style={{transform:"rotate(33deg)"}} id="1" lightColor={this.props.lightColor1} updateBox={this.props.updateBox}/>
          <Box targetKey="box" style={{transform:"rotate(11deg)", top:"55px"}} id="2" lightColor={this.props.lightColor2}  updateBox={this.props.updateBox}/>
          <Box targetKey="box" style={{transform:"rotate(0deg)", top:"65px"}}  id="3" lightColor={this.props.lightColor3} updateBox={this.props.updateBox}/>
          <Box targetKey="box" style={{transform:"rotate(348deg)", top:"55px"}}  id="4" lightColor={this.props.lightColor4} updateBox={this.props.updateBox}/>
          <Box targetKey="box" style={{transform:"rotate(327deg)"}}  id="5" lightColor={this.props.lightColor5}  updateBox={this.props.updateBox}/>
        </div>
        <div style={{clear: 'both'}}>&nbsp;</div>
        <div className="things_to_drag">
          <Boxable targetKey="box" title="Bubble Gum" style={{transform:"rotate(10deg)"}} image="./assets/foodfryer/BubbleGum_Icon.png"/>
          <Boxable targetKey="box" title="Butter" style={{transform:"rotate(20deg)"}}  image="./assets/foodfryer/Butter_Icon.png"/>
          <Boxable targetKey="box" title="Cheese Cake" style={{transform:"rotate(30deg)"}} image="./assets/foodfryer/Cheesecake_Icon.png"/>
          <Boxable targetKey="box" title="Chocolate Bar" style={{transform:"rotate(40deg)"}}  image="./assets/foodfryer/ChocolateBar_Icon.png"/>
          <Boxable targetKey="box" title="Cookie Dough" style={{transform:"rotate(150deg)"}} image="./assets/foodfryer/CookieDough_Icon.png"/>
          <Boxable targetKey="box" title="Ice Cream" style={{transform:"rotate(60deg)"}}  image="./assets/foodfryer/IceCream_Icon.png"/>
          <Boxable targetKey="box" title="Pickles" style={{transform:"rotate(70deg)"}} image="./assets/foodfryer/Pickles_icons.png"/>
          <Boxable targetKey="box" title="Thanksgiving Dinner" style={{transform:"rotate(80deg)"}}  image="./assets/foodfryer/ThanksgivingDinner_Icon.png"/>
        </div>
        <div style={{clear: 'both'}}>&nbsp;</div>
      </div>
    )
  }
}